import {FreeTrialPeriodModel} from './FreeTrialPeriod.model';
import {currentCartV2} from '@wix/ecom';

export class SubscriptionSettingsModel {
  public frequency: SubscriptionFrequency;
  public interval: number;
  public billingCycles: number;
  public startDate?: Date;
  public freeTrialPeriod: FreeTrialPeriodModel;
  public autoRenewal: boolean;
  public productPeriodAlignment?: ProductPeriodAlignment;

  constructor(params: SubscriptionSettingsModel) {
    this.frequency = params.frequency;
    this.interval = params.interval;
    this.billingCycles = params.billingCycles;
    this.startDate = params.startDate;
    this.freeTrialPeriod = params.freeTrialPeriod;
    this.autoRenewal = params.autoRenewal;
    this.productPeriodAlignment = params.productPeriodAlignment;
  }

  public static fromCartV2(subscriptionSettings: currentCartV2.SubscriptionSettings): SubscriptionSettingsModel {
    return new SubscriptionSettingsModel({
      frequency: toSubscriptionFrequency(subscriptionSettings?.frequency),
      interval: subscriptionSettings?.interval ?? 0,
      billingCycles: subscriptionSettings?.billingCycles ?? 0,
      startDate: subscriptionSettings?.startDate ?? undefined,
      freeTrialPeriod: FreeTrialPeriodModel.fromCartV2(subscriptionSettings?.freeTrialPeriod),
      autoRenewal: Boolean(subscriptionSettings?.autoRenewal),
      productPeriodAlignment: productPeriodAlignmentMap[subscriptionSettings?.productPeriodAlignment],
    });
  }
}

export enum ProductPeriodAlignment {
  ALIGNED_WITH_BILLING_PERIOD = 'ALIGNED_WITH_BILLING_PERIOD',
  NOT_ALIGNED_WITH_BILLING_PERIOD = 'NOT_ALIGNED_WITH_BILLING_PERIOD',
}

export enum SubscriptionFrequency {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  UNDEFINED = 'UNDEFINED',
}

export const toSubscriptionFrequency = (frequency?: currentCartV2.SubscriptionFrequencyWithLiterals | null) => {
  switch (frequency) {
    case 'DAY':
      return SubscriptionFrequency.DAY;
    case 'WEEK':
      return SubscriptionFrequency.WEEK;
    case 'MONTH':
      return SubscriptionFrequency.MONTH;
    case 'YEAR':
      return SubscriptionFrequency.YEAR;
    default:
      return SubscriptionFrequency.UNDEFINED;
  }
};

const productPeriodAlignmentMap: Record<ProductPeriodAlignment, ProductPeriodAlignment> = {
  [ProductPeriodAlignment.ALIGNED_WITH_BILLING_PERIOD]: ProductPeriodAlignment.ALIGNED_WITH_BILLING_PERIOD,
  [ProductPeriodAlignment.NOT_ALIGNED_WITH_BILLING_PERIOD]: ProductPeriodAlignment.NOT_ALIGNED_WITH_BILLING_PERIOD,
};
